module.exports = __webpack_public_path__ + "static/media/logo_primary.51218fa8.svg";